import { NgModule } from 'ng-metadata/core';

import {AlertFactory} from './alertFactory.service';
import {AlertBarService} from './alertBar.service';


@NgModule({
    declarations: [],
    providers: [
        AlertFactory,
        AlertBarService
    ],
    imports:[
    ]
})
export class AlertsModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/infra/widgets/alerts/alerts.module.ts